import { render, staticRenderFns } from "./underinfo.vue?vue&type=template&id=25c00330&"
import script from "./underinfo.vue?vue&type=script&lang=js&"
export * from "./underinfo.vue?vue&type=script&lang=js&"
import style0 from "./underinfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports